import {useState,useEffect,useRef} from "react";
import {Link} from "react-router-dom";
/* -- biz9 import start -- */
import {Str,Log,Status_Type} from "biz9-utility";
import {Message,Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Template,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
import {User_Table,User_Title,User_Service,User_Url,User_Role} from "biz9-user";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Remote_User} from "biz9-portal-app";
/* -- biz9 import end -- */
const Modal_User_Add = (props) => {
    const [val_sub_page_title,setValSubPageTitle] =  useState('Add ' + Str.get_table_by_name(Portal_Table.USER,{plural:true}));
	const [val_username,setValUserName] = useState("ceo" + Str.get_id());
	const [val_password,setValPassword] = useState("!Jessicap99");
	const [val_email,setValEmail] = useState("ceo@"+Str.get_id()+"gmail.com");
	useEffect(() => {
			},[props]);
    const updateValEmail = (event) => {
		setValEmail(event.target.value);
	};
	const updateValUserName = (event) => {
		setValUserName(event.target.value);
	};
	const updateValPassword = (event) => {
		setValPassword(event.target.value);
	};
	async function btn_post_user(){
        // -- post-user --
	        props.toast_loading(Message.SAVING);
			let item_new = Data_Logic.get(Portal_Table.USER,0,
					{data:{
						username:val_username,
						password:val_password,
						email:val_email,
                        role:User_Role.GUEST,
						setting_visible:"1",
					}});
					let [response,data] = await Portal_Remote_User.post(App.get_url(Portal_Url.USER_POST),item_new);
                    if(response.status == Status_Type.SUCCESS){
					    props.toast_success(response.message);
					    props.onUpdate(data);
                    }else{
		                props.toast_error(response.message);
                    }
    };
return (
		<>
		{/* Add Item */}
		<div className="modal new-modal fade" id="add_item" data-keyboard="false" data-backdrop="static">
		<div className="modal-dialog modal-dialog-centered">
		<div className="modal-content">
		<div className="modal-header">
		<button type="button" className="close-btn" data-bs-dismiss="modal">
		<span>×</span>
		</button>
		</div>
		</div>
		</div>
		</div>
		{/* /Add Item */}
		{/* Item */}
		<div className="modal new-modal fade" id="withdraw" data-keyboard="false" data-backdrop="static">
		<div className="modal-dialog modal-dialog-centered">
		<div className="modal-content">
		<div className="modal-header">
		<button type="button" className="close-btn" data-bs-dismiss="modal">
<span>×</span>
</button>
</div>
<div className="modal-body">
<div className="row">
<div className="col-md-12">
<div className="amt-wrap">
<div className="settings-card-head bg-light" style={{marginBottom:'15px'}} >
            <h4>{val_sub_page_title}</h4>
</div>

<div className="form-wrap">
<label className="form-label">
E-mail
<span className="text-danger ms-1">*</span>
</label>
<input value={val_email}  onChange={updateValEmail} type="text" className="form-control" />
</div>

<div className="form-wrap">
<label className="form-label">
UserName
<span className="text-danger ms-1">*</span>
</label>
<input value={val_username} onChange={updateValUserName} type="text" className="form-control" />
</div>


<div className="form-wrap">
<label className="form-label">
Password
<span className="text-danger ms-1">*</span>
</label>
<input value={val_password} onChange={updateValPassword} type="text" className="form-control" />
</div>




</div>

</div>
<div className="col-md-12">
<Link to={"#"} onClick={() => btn_post_user()}   className="btn btn-primary w-100">
{'Save'}
</Link>
</div>
</div>
</div>
</div>
</div>
</div>
{/* /Item */}
</>
);
};
export default Modal_User_Add;
